var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('BaseContainer',[_c('div',{staticClass:"defaultBox"},[_c('img',{staticClass:"defaultBox__image",attrs:{"alt":"merchant default","src":require("@assets/images/information_default.png")}}),_c('h1',{staticClass:"defaultBox__text"},[_vm._v("\n        404: "),(_vm.resource)?[_vm._v(_vm._s(_vm.resource))]:_vm._e(),_vm._v(" Not Found\n      ")],2),_c('router-link',{staticClass:"button is-primary is-rounded fix-width-200",attrs:{"to":{
            name: 'home',
            params: { merchantAlias: _vm.currentMerchant.alias },
            query: {
              language: _vm.$route.query.language,
            },
          }}},[_vm._v("\n        返回"+_vm._s(_vm.currentMerchant.name)+"\n      ")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }